// On AWS CodePipeline, this health route is pinged during deploy time and requires a 200 response
// in order for the deploy stage to complete

const HealthPage = () => <div>OK</div>

export default HealthPage
